/**
 * テスト環境専用: お問い合わせフォームのダミー入力
 * 有効ホスト: anshin-sozoku.guildrive.co.jp のみ
 * URL: ?fillDemo=1|fixed / ?fillDemo=random
 */

const DEV_HOST = "anshin-sozoku.guildrive.co.jp";

const FIXED = {
  name: "相続 太郎",
  pref: "東京都",
  email: "yaji@guildrive.co.jp",
  tel: "090-1234-5678",
  area: "札幌市中央区",
  category: ["不動産・空き家について（売却査定・管理・解体など）"],
  status: ["空き家になっている"],
  method: ["メールで返信してほしい"],
  time: "夜間（18:00〜19:00）",
  message:
    "実家が札幌にあり、誰も住む予定がないので売却を考えています。\n手続きに必要な費用を知りたいです。\n平日の夜にZoomで相談したいです。",
  privacy: true,
};

export function isContactDevHost() {
  return window.location.hostname === DEV_HOST;
}

export function initContactDevFill() {
  if (!isContactDevHost()) return;

  const form = findContactForm();
  if (!form) return;

  mountButtons(form);

  const mode = getModeFromUrl();
  if (mode) applyFill(form, mode);
}

/**
 * @param {HTMLFormElement} form
 * @param {"fixed" | "random"} mode
 */
export function applyFill(form, mode) {
  const data = mode === "random" ? buildRandom(form) : { ...FIXED };
  writeForm(form, data);
  notifyForm(form);
}

function findContactForm() {
  return (
    document.querySelector("#contact-form form.wpcf7-form") ||
    document.querySelector("#contact-form form.ctForm") ||
    document.querySelector("form.wpcf7-form") ||
    document.querySelector("form.ctForm")
  );
}

function getModeFromUrl() {
  const v = new URLSearchParams(window.location.search).get("fillDemo");
  if (v === "random") return "random";
  if (v === "1" || v === "true" || v === "fixed") return "fixed";
  return null;
}

/**
 * @param {HTMLFormElement} form
 */
function mountButtons(form) {
  const host =
    document.querySelector("#contact-form") ||
    form.closest(".ctInquiry__web") ||
    form.parentElement;
  if (!host || host.querySelector(".js-ct-dev-fill")) return;

  const wrap = document.createElement("div");
  wrap.className = "ctDevFill";
  wrap.innerHTML = `
    <p class="ctDevFill__note">開発用（テスト環境のみ表示）</p>
    <div class="ctDevFill__actions">
      <button type="button" class="ctDevFill__btn js-ct-dev-fill" data-mode="fixed">ダミー入力（固定）</button>
      <button type="button" class="ctDevFill__btn js-ct-dev-fill" data-mode="random">ダミー入力（ランダム）</button>
    </div>
  `;
  host.insertBefore(wrap, host.firstChild);

  wrap.querySelectorAll(".js-ct-dev-fill").forEach((btn) => {
    btn.addEventListener("click", () => {
      const current = findContactForm() || form;
      applyFill(current, btn.dataset.mode === "random" ? "random" : "fixed");
    });
  });
}

/**
 * @param {HTMLFormElement} form
 */
function buildRandom(form) {
  const prefs = optionValues(form, ["ct-pref", "ct_pref"], "select");
  const categories = optionValues(form, ["ct-category[]", "ct-category", "ct_category[]"], "checkbox");
  const statuses = optionValues(form, ["ct-status[]", "ct-status", "ct_status[]"], "checkbox");
  const methods = optionValues(form, ["ct-method[]", "ct-method", "ct_method[]"], "checkbox");
  const times = optionValues(form, ["ct-time", "ct_time"], "radio");

  return {
    name: pickOne(["相続 太郎", "山田 花子", "佐藤 次郎", "テスト ユーザー"]),
    pref: pickOne(prefs) || "北海道",
    email: "yaji@guildrive.co.jp",
    tel: `090-${String(randInt(1000, 9999))}-${String(randInt(1000, 9999))}`,
    area: pickOne(["札幌市中央区", "ニセコ町", "旭川市", "函館市", "帯広市"]),
    category: pickMany(categories.length ? categories : FIXED.category, randInt(1, 2)),
    status: pickMany(statuses.length ? statuses : FIXED.status, 1),
    method: pickMany(methods.length ? methods : FIXED.method, 1),
    time: pickOne(times.length ? times : [FIXED.time]),
    message: padText("遠方からの相続・空き家相談のテスト入力です。", randInt(40, 120)),
    privacy: true,
  };
}

/**
 * @param {HTMLFormElement} form
 * @param {typeof FIXED} data
 */
function writeForm(form, data) {
  setFieldValue(form, ["ct-name", "ct_name", "#ct-name", "#ct_name"], data.name);
  setSelectValue(form, ["ct-pref", "ct_pref", "#ct-pref", "#ct_pref"], data.pref);
  setFieldValue(form, ["ct-email", "ct_email", "#ct-email", "#ct_email"], data.email);
  setFieldValue(form, ["ct-tel", "ct_tel", "#ct-tel", "#ct_tel"], data.tel);
  setFieldValue(form, ["ct-area", "ct_area", "#ct-area", "#ct_area"], data.area);
  setFieldValue(form, ["ct-message", "ct_detail", "#ct-message", "#ct_detail"], data.message);

  setCheckGroup(form, ["ct-category[]", "ct-category", "ct_category[]"], data.category);
  setCheckGroup(form, ["ct-status[]", "ct-status", "ct_status[]"], data.status);
  setCheckGroup(form, ["ct-method[]", "ct-method", "ct_method[]"], data.method);
  setRadioValue(form, ["ct-time", "ct_time"], data.time);

  if (data.privacy) {
    const privacy = form.querySelector(
      'input[name="ct-privacy"], input[name="ct_privacy"], input.wpcf7-acceptance'
    );
    if (privacy) privacy.checked = true;
  }
}

/**
 * @param {HTMLFormElement} form
 */
function notifyForm(form) {
  form.querySelectorAll("input, select, textarea").forEach((el) => {
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  });
}

function setFieldValue(form, keys, value) {
  const el = findEl(form, keys);
  if (el) el.value = value;
}

function setSelectValue(form, keys, value) {
  const el = findEl(form, keys);
  if (!el) return;
  el.value = value;
}

function setRadioValue(form, names, value) {
  for (const name of names) {
    const el = form.querySelector(
      `input[type="radio"][name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`
    );
    if (el) {
      el.checked = true;
      return;
    }
  }
}

function setCheckGroup(form, names, values) {
  const set = new Set(values);
  let found = false;
  for (const name of names) {
    const inputs = form.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(name)}"]`);
    if (!inputs.length) continue;
    found = true;
    inputs.forEach((input) => {
      input.checked = set.has(input.value);
    });
  }
  if (!found) {
    // value マッチでフォールバック
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      if (set.has(input.value)) input.checked = true;
    });
  }
}

function findEl(form, keys) {
  for (const key of keys) {
    if (key.startsWith("#")) {
      const el = form.querySelector(key) || document.querySelector(key);
      if (el) return el;
      continue;
    }
    const el = form.querySelector(`[name="${CSS.escape(key)}"]`);
    if (el) return el;
  }
  return null;
}

function optionValues(form, names, type) {
  const values = [];
  for (const name of names) {
    const selector =
      type === "select"
        ? `select[name="${CSS.escape(name)}"] option`
        : `input[type="${type}"][name="${CSS.escape(name)}"]`;
    form.querySelectorAll(selector).forEach((el) => {
      const v = type === "select" ? el.value : el.value;
      if (v) values.push(v);
    });
    if (values.length) break;
  }
  return [...new Set(values)];
}

function pickOne(list) {
  if (!list.length) return "";
  return list[Math.floor(Math.random() * list.length)];
}

function pickMany(list, count) {
  const shuffled = [...list].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, list.length));
}

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function padText(seed, length) {
  let s = "";
  while (s.length < length) s += seed;
  return s.slice(0, length);
}
